export default __webpack_public_path__ + "static/media/Subscribe.785bbaf2.png";